import Check from "./Check/index.js";
class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/authz-profile`;
    }
    /**
     * Returns a list of user permissions granted at authorization procedure.
     * Please note: Some permissions may be restricted by extension type.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/authz-profile
     * Rate Limit Group: Medium
     */
    async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    check() {
        return new Check(this);
    }
}
export default Index;
